import { MIME_TYPES } from "@mantine/dropzone";
import { useEffect, useState } from "react";
import ImageUpload from "src/components/ImageUpload";
import EditorModal from "../PolicyEditor";
import { Button, Flex } from "@mantine/core";
import { useUpdatePolicyMutation } from "src/generated/graphql";
import { GetPolicy } from "src/api/graphql/queries/Policy";

interface IProps {
  isModify: Boolean;
  editorLink?: string;
  policyId?: string;
  closeModal?: (e?: boolean) => void;
}

const DocumentModal = ({
  isModify,
  editorLink,
  policyId,
  closeModal,
}: IProps) => {
  const [fileB64, setFileB64] = useState("");
  const [updatePolicy, { loading: UpdateLoading }] = useUpdatePolicyMutation({
    onCompleted: () => {
      const openEditModal = fileB64 && fileB64.trim() !== "" ? true : false;
      closeModal && closeModal(openEditModal);
    },
    refetchQueries: [{ query: GetPolicy, variables: { id: policyId } }],
  });

  const uploadDocument = async () => {
    if (policyId && fileB64) {
      const values = {
        fileB64,
      };
      try {
        await updatePolicy({
          variables: {
            data: { fileB64: values.fileB64 },
            id: policyId,
          },
        });
      } catch (e: any) {
        console.error("Error: ", e.response);
      }
    }
  };

  useEffect(() => {
    if (isModify && closeModal) {
      window.addEventListener("message", function (event) {
        if (event.data === "closeModal") {
          closeModal();
        }
      });
    }
  }, [isModify, closeModal]);

  return (
    <>
      {isModify && editorLink ? (
        <EditorModal link={editorLink} />
      ) : (
        <Flex direction={"column"}>
          <ImageUpload
            accept={[MIME_TYPES.pdf]}
            onReadSuccess={(b64) => setFileB64(b64)}
            src={fileB64}
            alt="Policy Pdf"
            isPdf={true}
            height="60vh"
            maxWidth="100%"
          />
          <Button
            onClick={uploadDocument}
            my={25}
            loading={UpdateLoading}
            disabled={!fileB64 || UpdateLoading}
          >
            Upload Document
          </Button>
        </Flex>
      )}
    </>
  );
};

export default DocumentModal;
